import AppConfig from 'config'

const getDebugLog = (key = 'debug') => {
  if (AppConfig.debug?.[key] || AppConfig.debug?.all) {
    return {
      log: (...args: any[]) => console.log(`${key}:`, ...args),
      warn: (...args: any[]) => console.warn(`${key}:`, ...args),
    }
  }
  return {
    log: () => undefined,
    warn: () => undefined,
  }
}

export const debugFrames = getDebugLog('frames')
export const debugOrder = getDebugLog('order')
export const debugNav = getDebugLog('nav')
export const debugSteps = getDebugLog('steps')
export const debugQR = getDebugLog('qr')
export const debugConditions = getDebugLog('conditions')
export const debugTl = getDebugLog('tl')
export const debugAuth = getDebugLog('auth')
export const debugAvatar = getDebugLog('avatar')

export default getDebugLog
